import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatCurrency(amount) {
  if (amount === undefined || amount === null) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function getStatusColor(status) {
  switch (status?.toLowerCase()) {
    case 'active':
      return 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30';
    case 'suspended':
      return 'bg-amber-500/20 text-amber-400 border-amber-500/30';
    case 'terminated':
      return 'bg-red-500/20 text-red-400 border-red-500/30';
    case 'open':
      return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
    case 'closed':
      return 'bg-slate-500/20 text-slate-400 border-slate-500/30';
    case 'pending':
      return 'bg-amber-500/20 text-amber-400 border-amber-500/30';
    case 'approved':
      return 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30';
    case 'rejected':
      return 'bg-red-500/20 text-red-400 border-red-500/30';
    default:
      return 'bg-slate-500/20 text-slate-400 border-slate-500/30';
  }
}

export function getCaseTypeColor(type) {
  switch (type) {
    case 'Verbal Warning':
      return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
    case 'Written Warning':
      return 'bg-amber-500/20 text-amber-400 border-amber-500/30';
    case 'Final Warning':
      return 'bg-orange-500/20 text-orange-400 border-orange-500/30';
    case 'Hearing':
      return 'bg-purple-500/20 text-purple-400 border-purple-500/30';
    case 'Suspension':
      return 'bg-red-500/20 text-red-400 border-red-500/30';
    default:
      return 'bg-slate-500/20 text-slate-400 border-slate-500/30';
  }
}

export function getLeaveTypeColor(type) {
  switch (type) {
    case 'Annual Leave':
      return 'bg-indigo-500/20 text-indigo-400 border-indigo-500/30';
    case 'Sick Leave':
      return 'bg-red-500/20 text-red-400 border-red-500/30';
    case 'Study Leave':
    case 'Family Responsibility Leave':
      return 'bg-purple-500/20 text-purple-400 border-purple-500/30';
    case 'Unpaid Leave':
      return 'bg-slate-500/20 text-slate-400 border-slate-500/30';
    case 'Public Holiday Leave':
      return 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30';
    default:
      return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
  }
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function hasPermission(userRole, allowedRoles) {
  return allowedRoles.includes(userRole);
}
